import { getTicketTypeHot, getTicketStandHot } from "../service";
import pageStyle from "./index.module.less";
import TimePicker from "@/components/timePicker";
import LangSelect from "@/components/langSelect";
import ChannelSelect from "@/components/channelSelect/index";
import TagType from "@/views/ticket/components/type/tag";
import checkAuth from "@/lib/auth";

export default {
    name: "TicketHot",
    components: { TimePicker, LangSelect, ChannelSelect, TagType },
    data() {
        return {
            pageStyle,
            totalCount: 0,
            query: {
                channels: "",
                time: [],
                language: ""
            },
            pageType: {
                pageSize: 30,
                currentPage: 1
            },
            pageTypeData: {
                tableData: [],
                totalCount: 0
            },
            pageStand: {
                pageSize: 30,
                currentPage: 1
            },
            pageStandData: {
                tableData: [],
                totalCount: 0
            },
            questionId: ""
        };
    },
    computed: {
        showExport() {
            return checkAuth("analysisticket.hot.export");
        }
    },
    watch: {
        "$i18n.locale"() {
            this.getTicketTypeHot();
            this.getTicketStandHot();
        },
        query: {
            deep: true,
            handler() {
                this.pageStand.currentPage = 1;
                this.pageType.currentPage = 1;
                this.getTicketTypeHot();
                this.getTicketStandHot();
            }
        },
        pageType: {
            deep: true,
            handler() {
                this.getTicketTypeHot();
            }
        },
        pageStand: {
            deep: true,
            handler() {
                this.getTicketStandHot();
            }
        },
        questionId: function() {
            this.pageStand.currentPage = 1;
            this.getTicketStandHot();
        }
    },
    methods: {
        channelSelect(data) {
            this.query.channels = data;
        },
        async getTicketTypeHot(downloadExport = 0) {
            let { time, ...reset } = this.query;

            let { list, pagination, download } = await getTicketTypeHot({
                ...reset,
                ...this.pageType,
                end_time: Math.floor(time[1].getTime() / 1000),
                start_time: Math.floor(time[0].getTime() / 1000),
                export: downloadExport
            });

            if (download) {
                window.open(download);
                return;
            }

            this.pageTypeData.tableData = list;
            this.pageTypeData.totalCount = pagination.totalCount;
        },
        async getTicketStandHot(downloadExport = 0) {
            let { time, ...reset } = this.query;
            let { list, pagination, download } = await getTicketStandHot({
                ...reset,
                ...this.pageStand,
                tag_id: this.questionId,
                end_time: Math.floor(time[1].getTime() / 1000),
                start_time: Math.floor(time[0].getTime() / 1000),
                export: downloadExport
            });

            if (download) {
                window.open(download);
                return;
            }

            this.pageStandData.tableData = list;
            this.pageStandData.totalCount = pagination.totalCount;
        }
    }
};
